import validateCustomThousand from '@/helpers/validateCustomThousand'

export default {
  getMessage(field, args) {
    return field
  },
  validate(value, args) {
    return validateCustomThousand(value)
  }
}
